import random from 'toxilibs/random.js'
import Level from '../core/level.js'

const level = new Level({
    name: 'substractions',
    dependencies: [
        'levels_maths/_easy_substractions_only_positive'
    ]
})


function common (q, a, b) {
    q.addText(a + ' - ' + (b < 0 ? '(' + b + ')' : b) + ' = ?')
    q.answer = a - b
}


level.addQuestion({
    generator: function (q) {
        let a = random.fairChoiceInt(1, 6, {name: 'a'})
        common(
            q,
            a,
            a + random.fairChoiceInt(1, 6, {name: 'b'})
        )
    }
})


level.addQuestion({
    generator: function (q) {
        common(
            q,
            random.fairChoiceInt(-5, -1, {name: 'a'}),
            random.fairChoiceInt(1, 5, {name: 'b'})
        )
    }
})



function minusMinus (q) {
    common(
        q,
        random.fairChoiceInt(1, 5, {name: 'a'}),
        random.fairChoiceInt(-5, -1, {name: 'b'})
    )
}


level.addQuestion({
    generator: minusMinus
})


level.addQuestion({
    generator: function (q) {
        let a = random.fairChoiceInt(100, 7000, {name: 'a'})
        let b = random.fairChoiceInt(100, 2000, {name: 'b'})
        q.addText(a + ' + ' + b + ' = ' + (a + b))
        common(q, a, -b)
    }
})


level.addQuestion({
    generator: minusMinus
})


level.addQuestion({
    generator: function (q) {
        common(
            q,
            random.fairChoiceInt(-4, -1, {name: 'a'}),
            random.fairChoiceInt(-5, -1, {name: 'b'})
        )
    }
})


export default level

